import React, {useState} from 'react';
import {toast} from 'react-toastify';
import {Button, Input} from 'reactstrap';
import {getInstagramPreviewForEntity} from 'utils/api';
import SpinnerButton from 'components/SpinnerButton';

const AddInstagramSourceInput = ({activeEntityId, addSourceToEntity, setPreventActions}) => {
    const [fetchingContent, setFetchingContent] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const fetchInstagramContent = async() => {
        try {
            setFetchingContent(true);
            setPreventActions(true);
            const params = {
                url: inputValue ? inputValue.trim() : '',
                entityId: activeEntityId,
            };
            let data = await getInstagramPreviewForEntity(params);
            addSourceToEntity(data.content, 'instagram');
            setInputValue('');
            toast.info('Source successfully added');
            setFetchingContent(false);
        } catch(e) {
            setFetchingContent(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
            }
            throw e.message;
        }
    };

    const handleSearchChange = (e) => {
        if(e.key === 'Enter') {
            if(e.target.value.trim()) {
                fetchInstagramContent();
            }
        } else {
            handleInputChange(e.target.value);
        }
    };

    const handleInputChange = (value) => {
        setInputValue(value);
    };

    return (
        <div className="w-100">
            <div className="d-flex">
                <div className="w-100 d-flex">
                    <div className="d-flex justify-content-between w-100">
                        <div className="position-relative w-100">
                            <i className="fab fa-instagram add-entity-source-input-icon instagram-feed-icon"/>
                            <Input
                                onKeyPress={(e) => handleSearchChange(e)}
                                onChange={(e) => handleSearchChange(e)}
                                value={inputValue}
                                placeholder="Enter an Instagram account"
                                type="text"
                                className="create-fetch_input"
                                style={{padding: '0 40px'}}
                                autoComplete="off"
                            />
                            {inputValue && inputValue.trim() && (
                                <i
                                    onClick={() => handleInputChange('')}
                                    className="fa fa-times-circle"
                                    style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        right: '0',
                                        top: '0',
                                        padding: '10.5px',
                                    }}
                                />
                            )}
                        </div>
                        <div style={{marginLeft: '10px'}}>
                            <SpinnerButton
                                minWidth="75px"
                                title="Add"
                                iconClass="fas fa-plus"
                                submitting={fetchingContent}
                                onClick={fetchInstagramContent}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddInstagramSourceInput;
